export default "__VITE_ASSET__BAH2hZEA__"